import type { SupportChatFeatureConfig } from './type';

export const supportChat: Partial<SupportChatFeatureConfig> = {
    showClientIdentity: false,
};
